import AdminSinchTemplates from '../../pages/sinch/AdminSinchTemplates.vue';
import SinchConfigurations from '../../pages/sinch/SinchConfigurations.vue';
import SinchConfiguration from '../../pages/sinch/SinchConfiguration.vue';
import EditSinchConfiguration from '../../pages/sinch/EditSinchConfiguration.vue';
import CreateSinchTemplate from '../../pages/sinch/CreateSinchTemplate.vue';
import EditSinchTemplate from '../../pages/sinch/EditSinchTemplate.vue';

export default [
  {
    path: '/v2/admin/text-messages/configurations',
    name: 'admin.sinch_configurations.index',
    component: SinchConfigurations,
    meta: {
      title: 'Text Message Configurations',
    },
  },
  {
    path: '/v2/admin/text-messages/configurations/:configurationID(\\d+)',
    component: SinchConfiguration,
    children: [
      {
        path: 'edit',
        name: 'admin.sinch_configuration.edit',
        component: EditSinchConfiguration,
        meta: {
          title: 'Edit Text Message Configuration',
        },
      }
    ],
  },
  {
    path: '/v2/admin/text-messages/templates',
    name: 'admin.sinch_templates.index',
    component: AdminSinchTemplates,
    meta: {
      title: 'Text Message Templates',
    }
  },
  {
    path: '/v2/admin/text-messages/templates/create',
    name: 'admin.sinch_template.create',
    component: CreateSinchTemplate,
    meta: {
      title: 'Create Text Message Template',
    },
  },
  {
    path: '/v2/admin/text-messages/templates/:templateID(\\d+)/edit',
    name: 'admin.sinch_template.edit',
    component: EditSinchTemplate,
    meta: {
      title: 'Edit Text Message Template',
    },
  }
]
